var _path, _path2;

const _excluded = ["title", "titleId"];

function _extends() { _extends = Object.assign ? Object.assign.bind() : function (target) { for (var i = 1; i < arguments.length; i++) { var source = arguments[i]; for (var key in source) { if (Object.prototype.hasOwnProperty.call(source, key)) { target[key] = source[key]; } } } return target; }; return _extends.apply(this, arguments); }

function _objectWithoutProperties(source, excluded) { if (source == null) return {}; var target = _objectWithoutPropertiesLoose(source, excluded); var key, i; if (Object.getOwnPropertySymbols) { var sourceSymbolKeys = Object.getOwnPropertySymbols(source); for (i = 0; i < sourceSymbolKeys.length; i++) { key = sourceSymbolKeys[i]; if (excluded.indexOf(key) >= 0) continue; if (!Object.prototype.propertyIsEnumerable.call(source, key)) continue; target[key] = source[key]; } } return target; }

function _objectWithoutPropertiesLoose(source, excluded) { if (source == null) return {}; var target = {}; var sourceKeys = Object.keys(source); var key, i; for (i = 0; i < sourceKeys.length; i++) { key = sourceKeys[i]; if (excluded.indexOf(key) >= 0) continue; target[key] = source[key]; } return target; }

import * as React from "react";

function SvgFailDelivery(_ref, svgRef) {
  let {
    title,
    titleId
  } = _ref,
      props = _objectWithoutProperties(_ref, _excluded);

  return /*#__PURE__*/React.createElement("svg", _extends({
    xmlns: "http://www.w3.org/2000/svg",
    width: 48,
    height: 48,
    fill: "none",
    viewBox: "0 0 48 48",
    ref: svgRef,
    "aria-labelledby": titleId
  }, props), title ? /*#__PURE__*/React.createElement("title", {
    id: titleId
  }, title) : null, _path || (_path = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    fillRule: "evenodd",
    d: "m15.602 35.998.056.059zM7.751 38.222l-.054.051zm7.851-2.224.056.059zM17.09 26.383a3.88 3.88 0 0 0-5.195 0l-.144.137-1.019 1.018a.23.23 0 0 1-.326 0L9.388 26.52l-.145-.137a3.88 3.88 0 0 0-4.854-.274c-.096.068-.235.003-.235-.115V12.74q0-1.235.903-2.141.902-.906 2.132-.907h22.758q1.23 0 2.021.96t1.014 2.088v4.295h3.84q.375 0 .68.155.306.156.527.456l5.518 7.363a1.5 1.5 0 0 1 .3.923v6.035q0 .645-.438 1.084t-1.08.44h-1.774q-.03 2.226-1.587 3.752t-3.779 1.526q-2.222 0-3.786-1.526-1.563-1.526-1.585-3.752H16.464a.26.26 0 0 1-.18-.075.33.33 0 0 1 0-.463l.95-.95a3.877 3.877 0 0 0 .137-5.338l-.137-.145zm19.918 8.813a2.48 2.48 0 0 1-1.826.76 2.48 2.48 0 0 1-1.827-.76 2.5 2.5 0 0 1-.757-1.834q0-1.073.757-1.834a2.48 2.48 0 0 1 1.827-.76q1.068 0 1.826.76.757.761.757 1.834 0 1.074-.757 1.834m4.005-8.482h-8.03v-6.621h3.085z",
    clipRule: "evenodd"
  })), _path2 || (_path2 = /*#__PURE__*/React.createElement("path", {
    fill: "currentColor",
    d: "m15.658 36.057-.056-.059-2.813-2.813 2.813-2.814a1.6 1.6 0 0 0 .429-.798 1.6 1.6 0 0 0-.084-.902l-.004-.01-.008-.019-.003-.006a1.6 1.6 0 0 0-.33-.484 1.57 1.57 0 0 0-2.22 0l-2.813 2.813-2.813-2.813a1.57 1.57 0 1 0-2.22 2.22l2.814 2.813-2.813 2.813a1.57 1.57 0 0 0 0 2.22l.011.011q.079.077.164.14a1.57 1.57 0 0 0 1.985-.096l.054-.051.005-.004 2.813-2.814 2.814 2.814a1.6 1.6 0 0 0 .65.39 1.57 1.57 0 0 0 1.51-.335l.06-.055a1.57 1.57 0 0 0 .055-2.16"
  })));
}

const ForwardRef = /*#__PURE__*/React.forwardRef(SvgFailDelivery);
export default __webpack_public_path__ + "static/media/fail-delivery.69495e9fef5ccab83e046271dbadf0a0.svg";
export { ForwardRef as ReactComponent };